import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { AdminDisputesListClient } from '@/components/admin/disputes-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/disputes')({
  component: AdminDisputesPage,
});

function AdminDisputesPage(): React.ReactElement {
  const t = useTranslations('admin.disputes');
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <PageHeader title={t('title')} subtitle={t('subtitle')} />
      <AdminDisputesListClient />
    </div>
  );
}
